function formatDate(date)
{
    date = new Date(date);

    let month = date.getMonth()+1;

    if (month < 10)
    {
        month = "0" + month;
    }

    let dateOfMonth = date.getDate();

    if (dateOfMonth < 10)
    {
        dateOfMonth = "0" + dateOfMonth;
    }

    let year = date.getFullYear();

    return dateOfMonth + "." + month + "." + year;
}

$(document).ready(function()
{
    $('.count-number-snippet').each(function () {
        var $this = $(this);
        $this.fadeIn();
        jQuery({ Counter: 0 }).animate({ Counter: $this.attr('data-stop') }, {
            duration: 2000,
            easing: 'swing',
            step: function (now) {
                $this.text(Math.ceil(now));
            }
        });
    });

    $("details").on("click", function () {
        $("details[open]").not(this).removeAttr("open");
    });
});